// src/Components/NewBusinessInsights/BusinessInsightsContent/Reports/Discounts/Discounts.js
import React, { useMemo } from "react";
import { Table } from "../../../../../shared/Table/Table";
import classes from "../../../newBusinessInsightsContent.module.scss";
import { useDiscountsReport } from "./hooks/useDiscountsReport";
import Header from "../../../components/Header";
import { useHeaderActions } from "../../../hooks/useHeaderActions";
import { Box } from "../../../../../shared/Box/Box";
import { Skeleton } from "../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../shared/Empty/Empty";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

const modalInfo = {
  title: "discountsReportNew.info.title",
  rows: [
    "discountsReportNew.info.clinicDiscounts",
    "discountsReportNew.info.providerDiscounts",
  ],
};

const DiscountsReport = () => {
  const { selectedClinic, period, apiPeriod } = useHeaderActions();
  const requestParams = {
    fromDate: apiPeriod.fromDate,
    toDate: apiPeriod.toDate,
    clinic_id:
      selectedClinic.value.value !== 0 ? [selectedClinic.value.value] : [],
  };
  const { data, isLoading } = useDiscountsReport(requestParams);

  const isClinicDataEmpty = !isLoading && !data?.clinicDiscounts?.length;
  const isProviderDataEmpty = !isLoading && !data?.providerDiscounts?.length;

  const clinicData = useMemo(
    () =>
      data?.clinicDiscounts.map((clinic) => ({
        clinicName: clinic.clinic_name,
        totalDiscounts: clinic.total_discounts,
      })),
    [data],
  );

  const providerData = useMemo(
    () =>
      data?.providerDiscounts.map((provider) => ({
        providerName: provider.provider,
        totalDiscounts: provider.total_discounts,
      })),
    [data],
  );

  const clinics =
    useMemo(
      () =>
        data?.clinics.map((clinic) => ({
          label: clinic.clinic_name,
          value: clinic.id,
        })),
      [data],
    ) || [];

  return (
    <div className="flex-col font-14 gap-16">
      <Header
        title="Discounts"
        selectedClinic={selectedClinic}
        clinics={clinics}
        period={period}
        downloadRoute={HTTP_ENDPOINTS.getDiscountsReport()}
        requestParams={requestParams}
        modalInfo={modalInfo}
      />
      <div className="flex gap-16">
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Clinic Name", accessor: "clinicName" },
              { data: "Total Discounts", accessor: "totalDiscounts" },
            ]}
            data={clinicData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isClinicDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Provider Name", accessor: "providerName" },
              { data: "Total Discounts", accessor: "totalDiscounts" },
            ]}
            data={providerData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isProviderDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default DiscountsReport;
